export default __webpack_public_path__ + "static/media/importDefault.2adbc287.svg";